import {useEffect, useRef} from 'react';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useBooleanState} from './useHelpCenterChatbot';
import {useHelpCenterChatbotActive} from './useHelpCenterChatbotActive';

export const useShouldAutoShowHelpCenterChatbot = () => {
  const {isActive} = useHelpCenterChatbotActive();
  const {isAuthenticated} = useIsAuthenticated();
  const timerRef = useRef<NodeJS.Timeout>(undefined);

  const [shouldAutoShowHelpCenterChatbot, setShouldAutoShowHelpCenterChatbot] =
    useBooleanState('should_auto_show_help_center_chatbot');

  useEffect(() => {
    if (!timerRef.current && isAuthenticated) {
      timerRef.current = setTimeout(() => {
        // eslint-disable-next-line local-rules/set-state-in-use-effect
        setShouldAutoShowHelpCenterChatbot(true);
      }, 10 * 1000);
    }
  }, [isAuthenticated]);

  if (!isActive) {
    return false;
  }

  if (!isAuthenticated) {
    return false;
  }

  if (
    // eslint-disable-next-line local-rules/window-usage
    window.location.pathname !== '/h' &&
    // eslint-disable-next-line local-rules/window-usage
    !window.location.pathname.startsWith('/h/')
  ) {
    return false;
  }

  return shouldAutoShowHelpCenterChatbot;
};
